
import { routerReducer as routing } from 'react-router-redux'
import { combineReducers } from 'redux'
import actions from './actions'

export default combineReducers({
  routing,
  actions,
})



/** WEBPACK FOOTER **
 ** ./reducers/index.js
 **/


/** WEBPACK FOOTER **
 ** ./reducers/index.js
 **/